<header class="top-toolbar">
    <!-- Left Section: Logo + App Name -->
    <div class="left-section">
        <div class="logo-container">
            <a [routerLink]="['/core']" (click)="clickOnImg()">
                <img src="assets/bk_logo.png" alt="Logo" class="logo" />
            </a>
        </div>
        <span class="title">Bandhan Health Program</span>
    </div>

    <!-- Middle Section: Logged-in user name -->
    <div class="middle-section">
        <span class="user-name">Welcome, {{donorName ? donorName : 'Donor not found'}}</span>
    </div>

    <!-- Right Section: Logout -->
    <div class="right-section">
        <div class="profile" (click)="logout()">
            <span class="username">
                <i class="fa-solid fa-right-from-bracket"></i> Logout
            </span>
        </div>
    </div>
</header>